import React from 'react'
import { useTranslation } from 'react-i18next';
import { breadcrumbBg } from '../../assets/images';


const Breadcrumb = ({ title }) => {

  const { t } = useTranslation();
  return (
   <div 
        className='bg-black/60 flex justify-center items-center'
        style={{
          position: 'relative',
          overflow: 'hidden',
          backgroundImage: `url(${breadcrumbBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          width: '100%',
          height: window.innerWidth < 640 ? '208px' : '208px',
        }}
      >
      <div className="md:max-w-container max-w-containerSm mx-auto font-secondFont">
      <div className="w-full text-white">
        <p className='text-[28px] md:text-[36px] font-medium text-center'>{title}</p>
     <div className='text-[16px] flex items-center justify-center mt-[4px]'>
  <p>{t("Ana səhifə")}</p>
  <i className={`fas fa-chevron-right mx-2`} /> 
  <p>{title}</p>
</div> 

        </div> 
    
  </div>
   </div>
  )
} 

export default Breadcrumb  